import { useState } from 'react';

import { VInput } from '../VInput';
import { VStack } from '../VStack';
import { CheckBoxOutlineBlank, SelectCheckBox } from '../asset';
import { usePickListContext } from './hook';
import style from './style';

type VGroupItemListProps = {
  itemListTitle?: string;
  searchInputPlaceHoder?: string;
  groupAllText?: string;
};

const VGroupItemList = ({
  itemListTitle,
  searchInputPlaceHoder,
  groupAllText,
}: VGroupItemListProps) => {
  const {
    selectedGroup,
    renderItem,
    isGroupAllSelected,
    toggleItem,
    toggleGroup,
    isItemSelected,
  } = usePickListContext();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredItemList = selectedGroup.itemList.filter(item =>
    item.value.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <VStack className={style.itemList} gap={1}>
      <div className={style.itemListTitle}>{itemListTitle || 'Items'}</div>

      <VInput
        fluid
        placeholder={searchInputPlaceHoder}
        type="search"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />

      <div className={style.itemsContainer}>
        {!searchTerm && (
          <button
            className={style.allGroupItem}
            aria-pressed={isGroupAllSelected(selectedGroup)}
            onClick={toggleGroup}
          >
            {isGroupAllSelected(selectedGroup) ? (
              <SelectCheckBox className={style.checkIcon} />
            ) : (
              <CheckBoxOutlineBlank className={style.checkIcon} />
            )}
            <span>{groupAllText || 'All groups'}</span>
          </button>
        )}
        {filteredItemList.map(item => {
          return (
            <button
              key={item.value}
              className={style.itemContainer}
              aria-pressed={isItemSelected(item)}
              onClick={() => toggleItem(item)}
            >
              {isItemSelected(item) ? (
                <SelectCheckBox className={style.checkIcon} />
              ) : (
                <CheckBoxOutlineBlank className={style.checkIcon} />
              )}
              {renderItem(item)}
            </button>
          );
        })}
      </div>
    </VStack>
  );
};

export default VGroupItemList;
